<rd-popup-default-template
  [title]="dialogData?.title | translate"
  [dialogContent]="dialogContent"
  [showCloseButton]="!!dialogData?.showCloseButton"
  [showButtons]="true"
  [showSecondaryButton]="!!dialogData?.secondaryButtonLabel"
  [primaryButtonText]="dialogData?.primaryButtonLabel | translate"
  (primaryButtonClick)="primaryClick()"
  [secondaryButtonText]="dialogData?.secondaryButtonLabel | translate"
  (secondaryButtonClick)="secondaryClick()">
  <ng-template #dialogContent>
    <div class="container m-0">
      <div
        class="description text-center"
        [innerHTML]="dialogData?.body | translate: dialogData?.bodyData"></div>
    </div>
  </ng-template>
</rd-popup-default-template>
